
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class StockAllocationItemsBOMGrid extends Serenity.EntityGrid<StockAllocationItemsBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.StockAllocationItemsBOM'; }
        protected getDialogType() { return StockAllocationItemsBOMDialog; }
        protected getIdProperty() { return StockAllocationItemsBOMRow.idProperty; }
        protected getInsertPermission() { return StockAllocationItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return StockAllocationItemsBOMRow.localTextPrefix; }
        protected getService() { return StockAllocationItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}